// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js!../../../css/App.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.help-centre {
    padding: 2rem;
    max-width: 900px;
    margin: 0 auto;
}

.help-title {
    margin-bottom: 1rem;
}

.help-contact {
    margin-bottom: 2rem;
    line-height: 1.6;
}

.help-email {
    color: #0066cc;
    text-decoration: none;
}

    .help-email:hover {
        text-decoration: underline;
    }

.help-table {
    width: 100%;
    border-collapse: collapse;
}

.help-th {
    text-align: left;
    border-bottom: 2px solid #ccc;
    padding: 0.75rem;
    font-weight: 600;
}

.help-row:nth-child(even) {
    background: #fafafa;
}

.help-question,
.help-answer {
    padding: 0.75rem;
    border-bottom: 1px solid var(--color-border);
    vertical-align: top;
}

.help-question {
    font-weight: 600;
    width: 30%;
}
`, "",{"version":3,"sources":["webpack://./src/assets/Documents/css/HelpCentre.css"],"names":[],"mappings":"AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;IAEI;QACI,0BAA0B;IAC9B;;AAEJ;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,6BAA6B;IAC7B,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,gBAAgB;IAChB,4CAA4C;IAC5C,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,UAAU;AACd","sourcesContent":["@import '../../../css/App.css';\r\n\r\n.help-centre {\r\n    padding: 2rem;\r\n    max-width: 900px;\r\n    margin: 0 auto;\r\n}\r\n\r\n.help-title {\r\n    margin-bottom: 1rem;\r\n}\r\n\r\n.help-contact {\r\n    margin-bottom: 2rem;\r\n    line-height: 1.6;\r\n}\r\n\r\n.help-email {\r\n    color: #0066cc;\r\n    text-decoration: none;\r\n}\r\n\r\n    .help-email:hover {\r\n        text-decoration: underline;\r\n    }\r\n\r\n.help-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n}\r\n\r\n.help-th {\r\n    text-align: left;\r\n    border-bottom: 2px solid #ccc;\r\n    padding: 0.75rem;\r\n    font-weight: 600;\r\n}\r\n\r\n.help-row:nth-child(even) {\r\n    background: #fafafa;\r\n}\r\n\r\n.help-question,\r\n.help-answer {\r\n    padding: 0.75rem;\r\n    border-bottom: 1px solid var(--color-border);\r\n    vertical-align: top;\r\n}\r\n\r\n.help-question {\r\n    font-weight: 600;\r\n    width: 30%;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
